import { render, staticRenderFns } from "./KSelect.vue?vue&type=template&id=039e6540"
import script from "./KSelect.vue?vue&type=script&lang=js"
export * from "./KSelect.vue?vue&type=script&lang=js"
import style0 from "./KSelect.vue?vue&type=style&index=0&id=039e6540&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
